import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class SettingService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAll(query: {}) {
        return this.baseApiFactory.getData<any[]>('/api/SystemSetting', query);
    }

    public Insert(value: {}) {
        return this.baseApiFactory.post(`/api/SystemSetting`, value);
    }
}

lazyRegister.service('SettingService', SettingService);
